/**
 * Ted #28 Phase 2 (#1050) — Gingr's per-condition alert moments, client side.
 *
 * A flag carries `alertAt` (creation / checkin / checkout); a surface asks
 * for the flags it should RAISE at its moment, not merely draw.
 * `flagsAlertingAt` is the registry's own (`dog-flags.ts`), not a copy: one
 * ranking for every surface (#1067 review). It tolerates this bundle's wire
 * type: a flag without `alertAt` (an older server) never alerts, and a key a
 * newer server sent sorts last within its severity.
 */
import type { DogFlag } from '../../lib/api.js';

export { flagsAlertingAt } from '@ferro/core/modules/dog-profile/dog-flags.js';

/** Dedupe by key across dogs (the family shares the owner's flags). */
export function uniqueByKey(flags: ReadonlyArray<DogFlag>): DogFlag[] {
  const seen = new Map<string, DogFlag>();
  for (const f of flags) if (!seen.has(f.key)) seen.set(f.key, f);
  return [...seen.values()];
}
